    //! bu nokta ve virgülleri ayırıyor
    //! ilk parametre sayının kendisi 2. kısım kaç basamak ondalık kısmı olacağı
    const formatConverter = (number, after=2) => {
        if (number === null || number === undefined || number === "" || Number.isNaN(Number(number))) {
            return "---"
        }
        return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: after, maximumFractionDigits: after }).format(number)
    }


    export default formatConverter
